<template>
	<div>
		<div class="process">
			<v-layout wrap>
				<div class="header-page">
					<v-flex xs5 md3 sm3 d-flex>
						<v-select
							class="select-core"
							height="40"
							hide-details
							label="Estados"
							outline
							single-line
							item-value="id"
							item-text="name"
							:items="states"
							v-model="filterStatus"
							:menu-props="{ contentClass: 'type-select-content' }"
							@input="filterRows($event, 'status')"
						></v-select>
					</v-flex>
					<button-clear
						value="Limpiar"
						@click="clearFilter">
					</button-clear>
				</div>
				<v-flex xs12 my-2>
					<process-list
						class="processList"
						:rows="processes"
						:last-page="lastPage"
						:total-items="totalItems"
						:current-page="currentPage"
						:total-items-visible="totalItemsVisible"
						:flag-num="flagNum"
						@click-icon="clickIcon"
						@on-page="changePage"
						@on-search-event="onSearchEvent"
						@changeSort="changeSort">
					</process-list>
				</v-flex>
			</v-layout>
			<modal-action
				:color="color"
				:dialog="openModal"
				:mostrar-btn="openButton"
				:title="title"
				@close-modal="closeModal"
				@create-employee="actionProcess">
			<div v-if="action === 'delete'">
				<h3 class="title-delete">{{ `¿Desea eliminar  el procesos ${processDelete.name}?` }}</h3>
			</div>
			</modal-action>
		</div>
	</div>
</template>

<script>
import buttonClear from '@/components/configuration/button-clear';
import processList from '@/modules/evaluation-360/components/process/process-list';
import helper from '@/shared/helper';
import modalAction from '@/components/evaluations/modal-action';

const { generateBlob, showDownloadDialog } = helper;

function created() {
	this.loadProcess();
}

function filterRows(filter, value) {
	this.flagNum += 1;
	this.params.sortField = null;
	this.params.sortDirection = null;
	this.paramsState[value] = filter;
	this.loadProcess();
}

function onSearchEvent(search) {
	this.params.search = search.trim() || null;
	this.changePage(1);
}

function clearFilter() {
	this.flagNum = 0;
	this.params.sortField = null;
	this.params.sortDirection = null;
	this.paramsState.status = null;
	this.filterStatus = '';
	this.loadProcess();
}

async function loadProcess() {
	const params = {
		...this.params,
		status: this.paramsState.status || null,
	};
	try {
		const { data: response, headers } = await this.$httpPraktiko.get('process', { params });
		this.processes = response;
		this.processes = this.processes.map((proces) => {
			const process = { ...proces };
			const totalEmpl = process.processEmployees.reduce((acum, item) => {
				let sum = acum;
				if (Object.keys(item.evaluators).length > 0) {
					item.evaluators.employees.forEach((emp) => {
						if (emp.status === 2) {
							sum += 1;
						}
					});
				} else {
					sum += 0;
				}
				return sum;
			}, 0);
			process.totalEmpl = totalEmpl || 0;
			return process;
		});
		this.lastPage = Number(headers['x-last-page']);
		this.totalItems = Number(headers['x-quantity']);
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		}
	}
}

function changeSort({ fieldName, sortDirection }) {
	this.params.sortField = fieldName;
	this.params.sortDirection = sortDirection;
	this.loadProcess();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadProcess();
}

function totalItemsVisible() {
	return this.processes.length;
}

function clickIcon(item) {
	if (item.action === 'delete') {
		this.processDelete.name = item.row.name;
		this.processDelete.id = item.row.id;
		this.action = 'delete';
		this.openModal = true;
		this.title = 'Eliminar';
		this.color = 'error';
	} else if (item.action === 'edit') {
		const idEdit = item.row.id;
		this.$store.dispatch('evaluation360/updateEmployeesByArea', []);
		this.$store.dispatch('evaluation360/assignProcess', null);
		this.$store.dispatch('evaluation360/saveJobIds', []);
		this.goTo('edit-configuration-process', { params: { id: idEdit } });
	} else if (item.action === 'report') {
		const processSelected = item.row;
		const processId = item.row.id;
		this.$store.dispatch('evaluation360/assignProcess', processSelected);
		this.goTo('report-evaluation', { params: { id: processId } });
	} else if (item.action === 'download') {
		const { contentType, type, row } = item;
		this.downloadReport(contentType, type, row);
	}
}

function actionProcess() {
	if (this.action === 'delete') {
		this.deleteProcess();
	}
}

async function deleteProcess() {
	try {
		await this.$httpPraktiko.delete(`process/${this.processDelete.id}`);
		this.showNotification('Procesos eliminado exitosamente');
		this.openModal = false;
		this.loadProcess();
	} catch (error) {
		this.showGenericError();
	}
}

function closeModal(val) {
	this.openModal = val;
	this.action = null;
	this.color = 'primary';
}

async function downloadReport(contentType, type, row) {
	const body = {
		processId: row.id,
		pollId: row.pollId,
	};
	try {
		const { data: pdfData } = await this.$httpPraktiko.post('reports/evaluation/excel', body, { responseType: 'blob' });
		const blob = generateBlob(pdfData, contentType);
		showDownloadDialog(blob, 'evaluation-360', type);
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		employees: [],
		processes: [],
		flagNum: 0,
		paramsState: {
			state: null,
		},
		params: {
			page: 1,
			limit: 15,
			sortField: null,
			sortDirection: null,
		},
		lastPage: 0,
		totalItems: 0,
		currentPage: 1,
		openButton: false,
		action: '',
		title: '',
		color: 'primary',
		rows: [],
		processDelete: {},
		openModal: false,
		states: [
			{
				id: 1,
				name: 'En Proceso',
			},
			{
				id: 2,
				name: 'Publicado',
			},
			{
				id: 3,
				name: 'Terminado',
			},
		],
		filterStatus: '',
	};
}

export default {
	name: 'page-list-process',
	created,
	data,
	beforeMount() {
		this.$store.dispatch('evaluation360/loadEvaluation360');
	},
	components: {
		buttonClear,
		processList,
		modalAction,
	},
	methods: {
		filterRows,
		clearFilter,
		changePage,
		loadProcess,
		clickIcon,
		actionProcess,
		deleteProcess,
		closeModal,
		onSearchEvent,
		downloadReport,
		changeSort,
		// loadEditProcess,
	},
	computed: {
		totalItemsVisible,
	},
};

</script>

<style lang="scss" scoped>
.processList {
	@media (max-width: 950px) {
			width: 700px;
			display: flex;
	}
}
.header-page {
	display: flex;
	justify-content: space-between;
	width: 100%;
	border: 1px solid map-get($colors, secondary);
	background-color: map-get($colors, white);
	padding: 10px 20px;
	border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/modules/evaluation-360/pages/page-list-process.vue